import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  media: {
    borderRadius: "20px",
    objectFit: "cover",
    width: "100%",
    maxHeight: "600px",
    boxShadow: "10px 10px 40px rgba(0, 0, 0, 0.5)",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "300px",
    },
  },
  card: {
    display: "flex",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      display: "flexwrap",
      flexDirection: "column",
    },
  },
  section: {
    borderRadius: "20px",
    margin: "10px",
    flex: 1,
  },
  imageSection: {
    marginLeft: "20px",
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0,
    },
  },
  recommendedPosts: {
    display: "flex",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  title: {
    fontFamily: "merriweather",
  },
  tags: {
    fontWeight: 600,
    fontSize: "20px",
    fontFamily: "merriweather",
    color: "#565656",
    textDecoration: "none",
    webkitTransition: "all 0.3s ease",
    oTransition: "all 0.3s ease",
    transition: "all 0.3s ease",
    maxWidth: "600px",
    "&:hover": {
      webkitTransform: "translate(10px, -10px)",
      msTransform: "translate(10px, -10px)",
      transform: "translate(5px, -5px)",
      webkitBoxShadow: "0 20px 40px rgba(0, 0, 0, 0.08)",
      color: "#22a86a",
    },
  },
  tagsLabels: {
    fontWeight: 600,
    fontSize: "20px",
    fontFamily: "merriweather",
    color: "#565656",
    textDecoration: "none",
    webkitTransition: "all 0.3s ease",
    oTransition: "all 0.3s ease",
    transition: "all 0.3s ease",
    maxWidth: "600px",
    "&:hover": {
      webkitTransform: "translate(10px, -10px)",
      msTransform: "translate(10px, -10px)",
      transform: "translate(5px, -5px)",
      webkitBoxShadow: "0 20px 40px rgba(0, 0, 0, 0.08)",
      color: "#677f92",
    },
  },
  message: {
    margin: "20px 0 20px 0",
    fontFamily: "merriweather",
    color: "#9E9E9E",
  },
  name: {
    fontFamily: "merriweather",
    fontWeight: 600,
    fontSize: "24px",
    margin: "10px 0 10px 0",
  },
  restOfText: {
    fontFamily: "merriweather",
    fontWeight: 600,
    color: "#565656",
    fontSize: "18px",
    margin: "0 0 10px 0",
  },
  loadingPaper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
    borderRadius: "15px",
    height: "39vh",
  },
  mediaBottom: {
    borderRadius: 10,
    boxShadow: "10px 10px 40px rgba(0, 0, 0, 0.5)",
    webkitTransition: "all 0.3s ease",
    oTransition: "all 0.3s ease",
    transition: "all 0.3s ease",
    maxWidth: "600px",
    "&:hover": {
      webkitTransform: "translate(10px, -10px)",
      msTransform: "translate(10px, -10px)",
      transform: "translate(5px, -5px)",
      webkitBoxShadow: "0 20px 40px rgba(0, 0, 0, 0.08)",
      color: "#677f92",
    },
    [theme.breakpoints.down("sm")]: {
      maxWidth: "300px",
    },
  },
  container: {},
  commentsOuterContainer: {
    display: "flex",
    justifyContent: "space-between",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
    },
  },
  commentsInnerContainer: {
    height: "280px",
    overflowY: "auto",
    marginRight: "30px",
  },
  [theme.breakpoints.down("sm")]: {
    alignItems: "center",
    height: "200px",
  },
  link: {
    textDecoration: "none",
    color: "inherit",
  },
  commentMessage: {
    margin: "10px",
    fontFamily: "merriweather",
    color: "#444a4a",
  },
}));
